import React, { JSX, useMemo, useState } from "react";
import { Table, TableColumnsType, Tag } from "antd";
import Text from "../../components/Text/Text";
import { actionColorOf } from "./actionColor";
import { AuditLogEntry } from "./mockData";
import { AlignTopTableContainer, CountRow } from "./styled";
import { useNavigate } from "react-router";

interface Props {
  auditLog: AuditLogEntry[];
}

function AuditLogTab({ auditLog }: Props): JSX.Element {
  const [search, setSearch] = useState("");
  const [action, setAction] = useState<string>("all");
  const navigate = useNavigate();

  const actionOptions = useMemo(() => {
    const actions = Array.from(new Set(auditLog.map((a) => a.action)));
    return [{ key: "all", value: "all", label: "ทุกการดำเนินการ" }, ...actions.map((a) => ({ key: a, value: a, label: a }))];
  }, [auditLog]);

  const filtered = useMemo(() => {
    const keyword = search.trim().toLowerCase();
    return auditLog.filter((a) => {
      if (action !== "all" && a.action !== action) return false;
      if (!keyword) return true;
      return a.code.toLowerCase().includes(keyword) || a.shop.toLowerCase().includes(keyword);
    });
  }, [auditLog, search, action]);

  const columns: TableColumnsType<AuditLogEntry> = [
    {
      title: "วันที่",
      key: "date",
      render: (_, r) => (
        <div>
          <Text fontFamily="Sarabun" fontSize={14} fontWeight={500} color="Text2">{r.date}</Text>
          <div>
            <Text fontFamily="Sarabun" fontSize={12} color="Text3">{r.time}</Text>
          </div>
        </div>
      ),
    },
    {
      title: "ร้านค้า",
      key: "shop",
      render: (_, r) => (
        <div>
          <Text fontFamily="Sarabun" fontSize={14} fontWeight={700} color="Text2">{r.shop}</Text>
          <div>
            <Text fontFamily="Sarabun" fontSize={12} color="Text3">จ.{r.province}</Text>
          </div>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (a: string) => (
        <Tag style={{ borderRadius: 16, border: "none" }} color={actionColorOf(a)}>
          <Text fontFamily="Sarabun" fontSize={13} fontWeight={700} color="white">{a}</Text>
        </Tag>
      ),
    },
    {
      title: "ก่อน",
      dataIndex: "before",
      key: "before",
      render: (v: string) => <Text fontFamily="Sarabun" fontSize={14} color="Text2">{v}</Text>,
    },
    {
      title: "หลัง",
      dataIndex: "after",
      key: "after",
      render: (v: string) => <Text fontFamily="Sarabun" fontSize={14} color="Text2">{v}</Text>,
    },
    {
      title: "เหตุผล",
      dataIndex: "reason",
      key: "reason",
      render: (v: string) => <Text fontFamily="Sarabun" fontSize={14} color="Text2">{v}</Text>,
    },
    {
      title: "ผู้ดำเนินการ",
      dataIndex: "actor",
      key: "actor",
      render: (v: string) => <Text fontFamily="Sarabun" fontSize={14} color="Text2">{v}</Text>,
    },
  ];

  return (
    <div>
      <CountRow>{filtered.length} รายการ</CountRow>
      <AlignTopTableContainer>
        <Table
          rowKey={(r) => `${r.code}-${r.date}-${r.time}`}
          dataSource={filtered}
          columns={columns}
          pagination={{ pageSize: 10 }}
          onRow={(record) => ({
            style: { cursor: "pointer" },
            onClick: () => navigate(`/ShopTier/detail/${record.code}`),
          })}
        />
      </AlignTopTableContainer>
    </div>
  );
}

export default AuditLogTab;
